import { Injectable } from "@angular/core";
import { User } from "../../_models/user";
import { Gym } from "../../_models/gym/Gym";
import {
  UpdateOrganizationRequest,
} from "../../_models/organization/Organization";
import { ReplaySubject } from "rxjs";
import { GlobalConstants } from "../../common/global-constants";
import { ApiService } from "../shared/api.service";
import { createOrganization } from "./organization.model";

@Injectable({
  providedIn: "root",
})
export class OrganizationService {
  private currentUserSource = new ReplaySubject<User>(1);
  currentUser$ = this.currentUserSource.asObservable();

  gymList!: Gym[];
  gym!: Gym;
  status: any;
  errorMessage: any;

  constructor(private apiService: ApiService) {}

  getOrganization(organizationId: string) {
    return this.apiService.get(
      `${GlobalConstants.orgUrl}organization/${organizationId}`
    );
  }

  createOrganization(body: createOrganization) {
    return this.apiService.post(`${GlobalConstants.orgUrl}organization`, body);
  }

  updateOrganization(
    updateOrganization: UpdateOrganizationRequest,
    organizationId: string
  ) {
    return this.apiService.put(
      `${GlobalConstants.orgUrl}organization/${organizationId}`,
      updateOrganization
    );
  }

  uploadOrganizationImage(organizationId: string, model: any) {
    return this.apiService.putFormData(
      `${GlobalConstants.orgUrl}organization/${organizationId}/upload`,
      model
    );
  }
}
